import * as React from 'react';
import * as styles from './styles.css';
var TITLE_DEFAULT = 'Не удалось получить возможные варианты';
var TEXT_DEFAULT = 'Попробуйте ещё раз';
export var Message = function Message(props) {
  var _props$title = props.title,
      title = _props$title === void 0 ? TITLE_DEFAULT : _props$title,
      _props$text = props.text,
      text = _props$text === void 0 ? TEXT_DEFAULT : _props$text;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['message_geo']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['message_text']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['message_text--title']
  }, /*#__PURE__*/React.createElement("strong", null, title)), /*#__PURE__*/React.createElement("div", {
    className: styles['message_text--light']
  }, text)));
};